import type { ReactElement } from 'react';
import LoginPage from '@quoruum/frontend-common/components/LoginPage';

export default function AdminLoginPage({ ssoEnabled }: { ssoEnabled: boolean }): ReactElement {
  return (
    <LoginPage
      pageName="Admin Login"
      noAccessMessage="You do not have access."
      googleOauth={ssoEnabled}
    />
  );
}
